var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EarTrainingGame',{attrs:{"choices":_vm.choices}},[_c('SubTitle',[_vm._v("Guess the interval")]),_c('p',[_vm._v(" Listen to the interval and try to guess it by ear. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }